import React from "react";
import {
  StepCard,
  StepTitle,
  StepSubtitle,
  FormGroup,
  SelectableCardsGrid,
  SelectableCard,
  NavigationButtonsRow,
  ActionButton,
} from "../registerStyles";

const TIPOS_ESTABLECIMIENTO = [
  {
    id: "independiente",
    icon: "🩺",
    title: "Consultorio Independiente",
    desc: "1 sillón dental / atención personalizada y directa",
  },
  {
    id: "clinica",
    icon: "🏥",
    title: "Clínica Dental",
    desc: "Múltiples sillones, sedes o equipo de especialistas",
  },
];

export const StepClinicType = ({
  formData,
  setFormData,
  onNext,
  onBack,
}) => {
  const isSelected = Boolean(formData.tipoEstablecimiento);

  return (
    <StepCard>
      <StepTitle>Tipo de Establecimiento</StepTitle>
      <StepSubtitle>
        Esto nos ayuda a configurar las herramientas adecuadas para tu operación.
      </StepSubtitle>

      <FormGroup>
        <SelectableCardsGrid columns={2}>
          {TIPOS_ESTABLECIMIENTO.map((tipo) => {
            const selected = formData.tipoEstablecimiento === tipo.id;
            return (
              <SelectableCard
                key={tipo.id}
                selected={selected}
                onClick={() => {
                  setFormData({ ...formData, tipoEstablecimiento: tipo.id });
                  onNext("tipoEstablecimiento", tipo.id);
                }}
              >
                <div className="icon-wrapper">{tipo.icon}</div>
                <h4 className="card-title">{tipo.title}</h4>
                <p className="card-description">{tipo.desc}</p>
              </SelectableCard>
            );
          })}
        </SelectableCardsGrid>
      </FormGroup>

      <NavigationButtonsRow>
        <ActionButton type="button" onClick={onBack}>
          ← Atrás
        </ActionButton>
      </NavigationButtonsRow>
    </StepCard>
  );
};
